import { LayoutDashboard, ListFilter, Send, Settings, Users } from 'lucide-react';

/** Primary navigation (SPEC §9 / UI_DESIGN.md information architecture). */
export const NAV_ITEMS = [
  { to: '/', label: 'Dashboard', icon: LayoutDashboard, end: true },
  { to: '/contacts', label: 'Contacts', icon: Users, end: false },
  { to: '/segments', label: 'Lists & Segments', icon: ListFilter, end: false },
  { to: '/campaigns', label: 'Campaigns', icon: Send, end: false },
  { to: '/settings', label: 'Settings', icon: Settings, end: false },
] as const;
